import { render, staticRenderFns } from "./Opening.vue?vue&type=template&id=3778d14e&"
import script from "./Opening.vue?vue&type=script&lang=js&"
export * from "./Opening.vue?vue&type=script&lang=js&"
import style0 from "./Opening.vue?vue&type=style&index=0&id=3778d14e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports